import React, { useEffect, useState } from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Typography from "@mui/material/Typography"
import useMediaQuery from "@mui/material/useMediaQuery"

import MobileMenu from "../components/5templates/MobileMenu"
import {Authenticate, checkSession} from '../common/sessionGate'
import { reExportedColors, ITooltip, Loader } from "../components/1elements"
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import dayjs from "dayjs"
import LocalizedFormat from "dayjs/plugin/localizedFormat"
import ApiService from '../common/ApiCalls'
import {formatSignInDate, formatSignInTime} from '../services/util/formatter'
import GoBackButton from '../components/1elements/Buttons/IconButtons/GoBackButton'

dayjs.extend(LocalizedFormat)
const useStyles = makeStyles((theme)=>({
    root: {
        height: "inherit",
    },
    mobileuser: {
        height: "inherit",
        paddingLeft: 14,
        width: "100%",
    },
    head: {
        marginTop: "15px",
        marginBottom: "8px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    HeadName: {
        fontSize: "22px",
        fontWeight: "bold",
        fontFamily: "Lato",
        color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        marginRight: 'auto'
    },
    Mobilehead: {
        marginTop: "70px",
        marginLeft: "10px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px",
        width: "480px",
    },
    TableRoot: {
        height: "65vh",
        maxWidth: '71vw',
        overflow: "auto",
    },
    Table: {
        width: "100%",
        height: "650px",
        borderCollapse: "collapse",
        borderSpacing: "8px",
        display: "table",
    },
    MobileTableRoot: {
        width: "450px",
    },
    TableHeaderRow: {
        background: theme.palette.secondary.accent,
        height: "45px",
        color: "white",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        position: "sticky",
        borderRadius: "4px",
        width: "100%",
    },
    TableHeader: {
        width: "158px",
        paddingLeft: "12px",
        margin: "4px",
        textAlign: "start",
        fontSize: "13px",
        display: "flex",
        alignItems: "flex-start",
        cursor: "pointer",
    },
    HoverDiv: {
        alignItems: "center",
        display: "flex",
        paddingLeft: "4px",
        fontFamily: "Roboto",
        "&:hover": {
            background: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
            borderRadius: "4px",
        },
        cursor: "pointer",
    },
    TableHeaderIcon: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "-4px",
    },
    UpIcon: {
        marginBottom: "-17px",
        // padding: '3px'
    },
    UpIconAfter: {
        marginBottom: "-17px",
        // padding: '3px',
        color: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    DownIcon: {
        marginTop: "-1px",
        // padding: '4px',
        color: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    DownIconAfter: {
        marginTop: "-1px",
        // padding: '4px'
    },
    TableBody: {},
    TableDataRow: {
        background: `${reExportedColors.TABLE_ROW}`, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        height: "40px",
        maxHeight: "45px",
        color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        fontSize: "11px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        marginTop: "4px",
        width: "100%",
    },
    TableData: {
        width: "158px",
        margin: "4px",
        textAlign: "start",
        fontSize: "13px",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        paddingLeft: "16px",
        fontFamily: "Roboto, sans-serif",
        color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },

    timeString: {
        paddingLeft: "2px",
        marginLeft: "2px",
        marginRight: "2px",
    },
    paginationConatiner: {
        display: "flex",
        justifyContent: "flex-end",
    },

    Pageroot: {
        width: "fit-content",
        height: "30px",
        padding: "4px",
        display: "flex",
    },
    pagelist: {
        marginLeft: "4px",
        marginRight: "4px",
        cursor: "pointer",
        fontSize: "13px",
        display: "flex",
        justifyContent: "center",
        fontFamily: "Roboto, sans-serif",
        fontWeight: "bold",
        "&:hover": {
            // background: reExportedColors.HOVER, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
            cursor: "pointer",
        },
    },
    PageDiv: {
        display: "flex",
        justifyContent: "center",
        color: "black",
        border: "none",
        background: "none",
    },

    pagination: {
        display: "flex",
        flexDirection: "row",
    },
    PageCount: {
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "Roboto, sans-serif",
        color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        marginRight: "4px",
    },
    pageDivSelected: {
        fontWeight: "bold",
        border: "none",
        background: "none",
    },
    goBackButton: {
        marginLeft: 10
    }
}))

function UserManagement() {
    const classes = useStyles()
    const isMatch = useMediaQuery("(max-width:750px)")
    const [userData, setuserData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(50)
    const [totalPosts, settotalPosts] = useState(0)

    const [userSort, setUserSort] = useState("desc")
    const [loginSort, setLoginSort] = useState("asc")
    const [, setLogoutSort] = useState("asc")
    const [statusSort, setStatusSort] = useState("asc")
    const [userAscending, setUserAscending] = useState(true)
    const [LoginAscending, setLoginAscending] = useState(false)
    const [LogoutAscending, setLogoutAscending] = useState(false)
    const [statusAscending, setstatusAscending] = useState(false)
    const [searchQuery, setsearchQuery] = useState("username")
    const [Order, setOrder] = useState("asc")

    useEffect(() => {
        checkSession()
        ApiService().getAllUsers({
            sortBy: `${searchQuery}`,
            order: `${Order}`,
            pageNo: currentPage,
            itemsPerPage: postsPerPage,
        })
            .then((res) => {
                settotalPosts(res.data.data.count)
                setuserData(res.data.data.users)
            })
            .catch((e) => {
                console.log(e)
            })
    }, [searchQuery, Order, currentPage, postsPerPage])

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    const pageNumbers = []
    for (let i = 1; i <= Math.ceil(17 / postsPerPage); i++) {
        pageNumbers.push(i)
    }

    const sortFunction = async (query) => {
        if (query === "username") {
            if (userAscending) {
                setUserSort("asc")
                setUserAscending(false)
            } else {
                setUserSort("desc")
                setUserAscending(true)
            }
            setsearchQuery(query)
            setOrder(userSort)
        }
        if (query === "last_login") {
            if (LoginAscending) {
                setLoginSort("asc")
                setLoginAscending(false)
            } else {
                setLoginSort("desc")
                setLoginAscending(true)
            }
            setsearchQuery(query)
            setOrder(loginSort)
        }
        if (query === "last_logout") {
            if (LogoutAscending) {
                setLogoutSort("asc")
                setLogoutAscending(false)
            } else {
                setLogoutSort("desc")
                setLogoutAscending(true)
            }
            setsearchQuery(query)
            setOrder(loginSort)
        }
        if (query === "status") {
            if (statusAscending) {
                setStatusSort("asc")
                setstatusAscending(false)
            } else {
                setStatusSort("desc")
                setstatusAscending(true)
            }
            setsearchQuery(query)
            setOrder(statusSort)
        }
    }

    return (
        <div className={isMatch ? classes.mobileuser : classes.root}>
            {isMatch ? <MobileMenu /> : ""}

            <div className={isMatch ? classes.Mobilehead : classes.head}>
                <Typography className={classes.HeadName}>
                    User Activity
                </Typography>
                <span className={classes.PageCount}>{`${
                    postsPerPage * (currentPage - 1) + 1
                }-${
                    postsPerPage * currentPage < totalPosts
                        ? postsPerPage * currentPage
                        : totalPosts
                } of ${totalPosts}`}</span>
                <GoBackButton className={classes.goBackButton} />
            </div>
            <div
                className={
                    !isMatch ? classes.TableRoot : classes.MobileTableRoot
                }
            >
                <div className={classes.Table}>
                    <div className={classes.TableHeaderRow}>
                        <div className={classes.TableHeader}>
                            <ITooltip placement="top" content="sort">
                                <div
                                    className={classes.HoverDiv}
                                    onClick={() => {
                                        sortFunction("username")
                                    }}
                                >
                                    <div>Name</div>
                                    <div className={classes.TableHeaderIcon}>
                                        <ArrowDropUpIcon
                                            className={
                                                userAscending
                                                    ? classes.UpIcon
                                                    : classes.UpIconAfter
                                            }
                                        />
                                        <ArrowDropDownIcon
                                            className={
                                                userAscending
                                                    ? classes.DownIcon
                                                    : classes.DownIconAfter
                                            }
                                        />
                                    </div>
                                </div>
                            </ITooltip>
                        </div>
                        <div className={classes.TableHeader}>
                            <ITooltip placement="top" content="Sort">
                                <div
                                    className={classes.HoverDiv}
                                    onClick={() => {
                                        sortFunction("status")
                                    }}
                                >
                                    <div>Status</div>
                                    <div className={classes.TableHeaderIcon}>
                                        <ArrowDropUpIcon
                                            className={
                                                statusAscending
                                                    ? classes.UpIcon
                                                    : classes.UpIconAfter
                                            }
                                        />
                                        <ArrowDropDownIcon
                                            className={
                                                statusAscending
                                                    ? classes.DownIcon
                                                    : classes.DownIconAfter
                                            }
                                        />
                                    </div>
                                </div>
                            </ITooltip>
                        </div>
                        <div className={classes.TableHeader}>
                            <ITooltip placement="top" content="Sort">
                                <div
                                    className={classes.HoverDiv}
                                    onClick={() => {
                                        sortFunction("last_login")
                                    }}
                                >
                                    <div>Last Sign in Date</div>
                                    <div className={classes.TableHeaderIcon}>
                                        <ArrowDropUpIcon
                                            className={
                                                LoginAscending
                                                    ? classes.UpIcon
                                                    : classes.UpIconAfter
                                            }
                                        />
                                        <ArrowDropDownIcon
                                            className={
                                                LoginAscending
                                                    ? classes.DownIcon
                                                    : classes.DownIconAfter
                                            }
                                        />
                                    </div>
                                </div>
                            </ITooltip>
                        </div>
                        <div className={classes.TableHeader}>
                            <ITooltip placement="top" content="Sort">
                                <div
                                    className={classes.HoverDiv}
                                    onClick={() => {
                                        sortFunction("last_login")
                                    }}
                                >
                                    <div>Last Sign in Time</div>
                                    <div className={classes.TableHeaderIcon}>
                                        <ArrowDropUpIcon
                                            className={
                                                LoginAscending
                                                    ? classes.UpIcon
                                                    : classes.UpIconAfter
                                            }
                                        />
                                        <ArrowDropDownIcon
                                            className={
                                                LoginAscending
                                                    ? classes.DownIcon
                                                    : classes.DownIconAfter
                                            }
                                        />
                                    </div>
                                </div>
                            </ITooltip>
                        </div>

                        <div className={classes.TableHeader}>
                            <ITooltip placement="top" content="Sort">
                                <div className={classes.HoverDiv} onClick={() => {sortFunction("last_logout")}}>
                                    <div>Last Sign out Date</div>
                                    <div className={classes.TableHeaderIcon}>
                                        <ArrowDropUpIcon className={LogoutAscending ? classes.UpIcon : classes.UpIconAfter}/>
                                        <ArrowDropDownIcon className={LogoutAscending ? classes.DownIcon : classes.DownIconAfter}/>
                                    </div>
                                </div>
                            </ITooltip>
                        </div>
                        <div className={classes.TableHeader}>
                            <ITooltip placement="top" content="Sort">
                                <div className={classes.HoverDiv} onClick={() => {sortFunction("last_logout")}}>
                                    <div>Last Sign out Time</div>
                                    <div className={classes.TableHeaderIcon}>
                                        <ArrowDropUpIcon className={LogoutAscending ? classes.UpIcon : classes.UpIconAfter}/>
                                        <ArrowDropDownIcon className={LogoutAscending ? classes.DownIcon : classes.DownIconAfter}/>
                                    </div>
                                </div>
                            </ITooltip>
                        </div>
                    </div>
                    <div className={classes.TableBody}>
                        {userData.length > 0 ? (
                            userData.map((person, i) => {
                                return (
                                    <div
                                        key={i}
                                        className={classes.TableDataRow}
                                    >
                                        <div className={classes.TableData}>
                                            {person.username}
                                        </div>
                                        <div className={classes.TableData}>
                                            {person.status}
                                        </div>
                                        <div className={classes.TableData}>
                                            <span className={classes.timeString}>
                                                {formatSignInDate(person.last_login)}
                                            </span>
                                        </div>
                                        <div className={classes.TableData} >
                                             <span className={classes.timeString}>
                                                {formatSignInTime(person.last_login)}
                                            </span>
                                        </div>

                                        <div className={classes.TableData}>
                                            <span className={classes.timeString}>
                                                {formatSignInDate(person.last_logout)}
                                            </span>
                                        </div>
                                        <div className={classes.TableData} >
                                             <span className={classes.timeString}>
                                                {formatSignInTime(person.last_logout)}
                                            </span>
                                        </div>
                                    </div>
                                )
                            })
                        ) : (
                            <div style={{ display: "flex", marginTop: "50%" }}>
                                <Loader />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className={classes.paginationConatiner}>
                <nav className={classes.Pageroot}>
                    <ul className={classes.pagination}>
                        {pageNumbers.map((number) => (
                            <li key={number} className={classes.pagelist}>
                                <button
                                    className={
                                        number === currentPage
                                            ? classes.pageDivSelected
                                            : classes.PageDiv
                                    }
                                    onClick={() => paginate(number)}
                                >
                                    {number}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Authenticate(UserManagement)
